import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetWorkloadResData } from "./GetWorkloadResData";
import { GetWorkloadReqData } from "./GetWorkloadReqData";

const ENDPOINT = "/cash_flow/workload"

export class FetchInstallationsWorkloadCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetWorkloadReqData;

    constructor(payload: GetWorkloadReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetWorkloadResData> {
        var res = await this.executeCommand(this.payload);
        return new GetWorkloadResData(res);
    }

}
